/**
 * web/ 엔트리포인트 (Issue #447 Phase A → #455 Phase H)
 *
 * Framework7 v9 + framework7-react 초기화. `app/src/main.tsx`와 동일 contract.
 *
 * - `framework7/css/bundle` 1회 import (부분 import 금지 — tabs/panel 등 plugin CSS 누락 방지)
 * - `framework7-icons` CSS import (아이콘 web font)
 * - `Framework7.use(Framework7React)` 는 `<F7App>` mount 이전 실행 필수
 *   (그렇지 않으면 `f7events.emit('ready')`가 undefined emitter에서 발사됨)
 * - `initializeI18n().then(() => render(...))` 로 i18n 준비 후 렌더 — FOUC 방지
 *   (app/src/main.tsx:32-37과 동일 contract — Issue #455 Step 2.0)
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import Framework7 from 'framework7/lite-bundle';
import Framework7React from 'framework7-react';
import { initializeI18n } from '@app/i18n/config';
import App from './App';

import 'framework7/css/bundle';
import 'framework7-icons';

// `Framework7.use` is the F7 plugin install API (not a React hook). The
// `react-hooks/rules-of-hooks` rule false-positives on the `use` prefix.
// eslint-disable-next-line react-hooks/rules-of-hooks
Framework7.use(Framework7React);

const container = document.getElementById('root');
if (!container) {
  throw new Error('#root container not found in index.html');
}

const root = createRoot(container);

void initializeI18n().then(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
